import { GRID_OPTIONS } from 'components/shared/AgTablePage/lib/constants';

export default function infiniteGridOptions({ isInfinite, limit }) {
  return {
    ...GRID_OPTIONS,
    suppressScrollOnNewData: true,
    ...(isInfinite
      ? {
          rowModelType: 'infinite',
          cacheBlockSize: limit,
          paginationPageSize: limit,
          maxBlocksInCache: 10,
          blockLoadDebounceMillis: 100
        }
      : {}),
    getRowId: (params) => params?.data?.id
  };
}
